<app-spo-detail-page-header [spoDetails]="spoDetails"
                            (contextMenuDelete)="contextMenuDelete()"
                            (contextMenuEdit)="contextMenuEdit()"
                            (contextMenuSend)="contextMenuSend()">
</app-spo-detail-page-header>

<div class="spo-detail-section-detail">
    <div class="section-heading">Detail</div>
    <div class="spo-detail-content">
        <app-spo-detail [spoDetail]="spoDetails"></app-spo-detail>
    </div>
</div>
<div class="spo-detail-section-material">
    <app-material-list [materials]="spoDetails.specialOrderMaterials"
                       [showBtnAdd]="false"
                       [showTooltipWarnings]="false"
                       [showExtraColumns]="spoDetails.status.code !== specialOrderStatus.DRAFT"
                       [transportDocumentType]="$safeNavigationMigration(spoDetails.transportMode?.transportDocumentType)"
                       [enableMaterialDetailView]="true">
    </app-material-list>
</div>

